import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MenuDoctor from "./navDoctor/MenuDoctor";

// import icon__home__public from '../../asset/image/right_home_public.svg'
import logo__home from "../../asset/image/logo.svg";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import ModalShowData from "../material/modal/ModalShowData";
import CheckBoxV2 from "../material/checkboxV2/CheckBoxV2";
import { HashLoader } from "react-spinners";
import * as MedicalApi from "../../service/medicalApi";
import { RedirectCode400 } from "../RedirectCode400";
import Button from "../material/button/Button";
import iconDown from "../../asset/icon/download-icon.svg";

import { CurrentUserContext } from "../../App";
import PopupGuidance from "./Guidance/PopupGuidance";
import { environment } from "../../config.env";

const ENDPOINT_DOMAIN = environment.endpoint_domain || "";
const PG_AUTHORIZATION_FILE = environment.pg_authorization_file || "";

// อันนี้หน้า component main ของหมอ  เมนู ค้นหาผู้ป่วย
function SearchDataPatient() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [resultSuccess, setResultSuccess] = useState(false);
  const [checkSearchPid, setCheckSearchPid] = useState(true);
  const [checkSearchFullName, setCheckSearchFullName] = useState(false);
  const [valuePid, setValuePid] = useState("");
  const [valueFname, setValueFname] = useState("");
  const [valueLname, setValueLname] = useState("");
  const [afterSearch, setAfterSearch] = useState([]);
  const [clickSavePermission, setClickSavePermisson] = useState(null);

  const [openModalGuidance, setOpenModalGuidance] = useState(false);

  // useEffect(() => {
  //   console.log(valueFname, valueLname)
  // }, [valueFname, valueLname])

  const toComponentPath = (path) => {
    navigate(path);
  };

  const postSearchPatient = async (pid, fname, lname) => {
    if (checkSearchFullName) {
      if (valueFname === "") {
        setIsMessage({ type: "warning", data: "กรุณาใส่ชื่อ" });
      } else if (valueLname === "") {
        setIsMessage({ type: "warning", data: "กรุณาใส่นามสกุล" });
      } else {
        let res = "";
        setLoading(true);
        res = await MedicalApi.postSearchPatient(pid, fname, lname);
        setLoading(false);
        if (res) {
          if (res["data"]["code"] === 200) {
            setAfterSearch(res["data"]["patient_list"]);
            setResultSuccess(true);
            if (res["data"]["patient_list"].length === 0) {
              setResultSuccess(false);
              setOpenModal(true);
            }
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    } else if (checkSearchPid) {
      if (valuePid === "") {
        setIsMessage({ type: "warning", data: "กรุณาใส่เลขบัตรประชาชน" });
      } else {
        let res = "";
        setLoading(true);
        res = await MedicalApi.postSearchPatient(pid, fname, lname);
        setLoading(false);
        if (res) {
          if (res["data"]["code"] === 200) {
            setAfterSearch(res["data"]["patient_list"]);
            setResultSuccess(true);
            if (res["data"]["patient_list"].length === 0) {
              setResultSuccess(false);
              setOpenModal(true);
            }
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    }
  };

  const postRequestCredential = async (item) => {
    let res = "";
    setLoading(true);
    res = await MedicalApi.postRequestCredential(item.uid);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        navigate("/doctor/permisstionLabPatient", {
          state: {
            credential_token: res["data"]["credential_token"],
          },
        });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else if (res["data"]["code"] === 405) {
        item.is_allow = res["data"]["is_allow"];
        item.message = res["data"]["message_th"];
        setClickSavePermisson(item);
        setOpenModal(true);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSiamScanCard = async () => {
    await MedicalApi.getSiamScanCard();
  };

  const getSiamScanCardManual = async () => {
    await MedicalApi.getSiamScanCardManual();
  };

  const clickOpenGuidance = () => {
    setOpenModalGuidance(true);
  };

  return (
    <div className="global-page">
      {openModal ? (
        <>
          {resultSuccess ? (
            <ModalShowData
              titlename={"แจ้งเตือน"}
              success
              detail={clickSavePermission}
              onClose={() => {
                setOpenModal(false);
              }}
            />
          ) : (
            <ModalShowData
              titlename={"แจ้งเตือน"}
              detail={"ไม่พบข้อมูลการตรวจแลปในระบบ"}
              onClose={() => {
                setOpenModal(false);
              }}
            />
          )}
        </>
      ) : null}

      <PopupGuidance
        show={openModalGuidance}
        onClose={() => {
          setOpenModalGuidance(false);
        }}
      />

      <MenuDoctor menuActive={"searchDataPatient"} />
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />

      <div className="grid grid-cols-[auto_5px_auto] lg:grid-cols-1 lg:mx-4 my-20">
        <div className="grid justify-center items-center gap-5">
          {/* <div className='py-10 px-24 rounded-3xl border-2 border-[#A2B5BC] active:bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] hover:cursor-pointer'>
            <div className='text-lg text-[#000000] text-center py-2'>เสียบบัตรประจำตัวประชาชน</div>
            <div className='w-full flex justify-center'>
              <img className='w-64' src={require('../../asset/image/insert_card_id.svg').default} />
            </div>
          </div>
          <div className='py-10 px-24 rounded-3xl border-2 border-[#A2B5BC] active:bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] hover:cursor-pointer'>
            <div className='text-lg text-[#000000] text-center py-2'>ค้นหาด้วย Digital ID</div>
            <div className='w-full flex justify-center'>
              <img className='w-48' src={require('../../asset/image/logo_digital_id.svg').default} />
            </div>
            <div className='text-[#000000] text-center'>สแกน QR Code ด้วยแอปพลิเคชัน OnesID</div>
          </div> */}
          <div style={{ margin: "15% 8%" }}>
            <img src="/icons/doctorSearch.svg" />
          </div>
          <div style={{ display: "grid", gridGap: 10 }}>
            <div
              onClick={clickOpenGuidance}
              style={{
                display: "grid",
                justifyItems: "center",
                color: "#FF8E5B",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              <div>
                ต้องการใช้งานระบบยืนยันตัวตนด้วยการเสียบบัตรประชาชนหรือไม่ ?
              </div>
              <div
                className="cursor-pointer hover:underline"
                onClick={() => getSiamScanCardManual()}
              >
                คลิกเพื่อดูคำแนะนำการใช้งาน
              </div>
            </div>
            <div className="w-[300px] m-[auto] lg:w-[250px]">
              <Button onClick={() => getSiamScanCard()}>
                <img src={iconDown} />
                <div style={{ marginLeft: "10px" }}>
                  ดาวน์โหลดโปรแกรมเสียบบัตร
                </div>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-1 border-[#A2B5BC] bg-[#A5DFD0] lg:hidden"></div>

        <div className="lg:my-5">
          <div className="flex w-full justify-center">
            <div className="rounded-3xl border-2 border-[#A2B5BC] w-8/12 sm:w-full p-6">
              <div className="text-lg text-[#000000] text-center">
                ค้นหาข้อมูลแลปของผู้ป่วย
              </div>

              <div className="flex justify-center items-center mt-6 gap-[20px]">
                <div className="flex justify-center items-center gap-[10px]">
                  <CheckBoxV2
                    value={checkSearchPid}
                    setValue={() => {
                      setCheckSearchPid(true);
                      setCheckSearchFullName(false);
                      setValueFname("");
                      setValueLname("");
                      setValuePid("");
                    }}
                    id="check1"
                  />
                  <div className="text-l text-[#000000] sm:text-center">
                    ค้นหาด้วยเลขบัตรประชาชน
                  </div>
                </div>
                <div className="flex justify-center items-center gap-[10px]">
                  <CheckBoxV2
                    value={checkSearchFullName}
                    setValue={() => {
                      setCheckSearchFullName(true);
                      setCheckSearchPid(false);
                      setValueFname("");
                      setValueLname("");
                      setValuePid("");
                    }}
                    id="check2"
                  />
                  <div className="text-l text-[#000000] sm:text-center">
                    ค้นหาด้วยชื่อและนามสกุล
                  </div>
                </div>
              </div>
              <div className="flex justify-center w-full gap-4 mt-4">
                {checkSearchPid ? (
                  <>
                    <input
                      className="border-[2px] border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#000000] p-5 focus:outline-none mt-1 mb-4 h-[10px] w-full placeholder-[#526F65]"
                      value={valuePid}
                      onChange={(e) => {
                        setValuePid(e.target.value);
                        setValueFname("");
                        setValueLname("");
                      }}
                      placeholder="เลขบัตรประชาชน"
                    ></input>
                  </>
                ) : (
                  <>
                    <input
                      className="border-[2px] border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#000000] p-5 focus:outline-none mt-1 mb-4 h-[10px] w-full placeholder-[#526F65]"
                      value={valueFname}
                      onChange={(e) => {
                        setValueFname(e.target.value);
                        setValuePid("");
                      }}
                      placeholder="ชื่อ"
                    ></input>

                    <input
                      className="border-[2px] border-solid border-[#A2B5BC] rounded-xl text=state-100 text-[#000000] p-5 focus:outline-none mt-1 mb-4 h-[10px] w-full placeholder-[#526F65]"
                      value={valueLname}
                      onChange={(e) => {
                        setValueLname(e.target.value);
                        setValuePid("");
                      }}
                      placeholder="นามสกุล"
                    ></input>
                  </>
                )}
              </div>
              <div className="flex justify-center items-center">
                <button
                  className="button-theme-pg flex justify-center items-center w-28 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
                  onClick={() => {
                    postSearchPatient(valuePid, valueFname, valueLname);
                    // setOpenModal(true)
                  }}
                >
                  <MagnifyingGlassIcon className="stroke-[#526F65] w-4" />
                  <div className="text-sm text-[#000000]">ค้นหา</div>
                </button>
              </div>
            </div>
          </div>

          <div className="flex w-full justify-center">
            <div className="rounded w-full p-10 md:p-2">
              {afterSearch.length > 0 ? (
                afterSearch.map((item, idx) => {
                  return (
                    <div key={idx}>
                      <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] my-[15px]"></div>
                      <div
                        className="flex justify-center items-center gap-10"
                        key={idx}
                      >
                        {item["pname"] +
                          " " +
                          item["fname"] +
                          " " +
                          item["lname"]}
                        <Button
                          onClick={() => {
                            postRequestCredential(item);
                          }}
                        >
                          ขอเข้าถึงข้อมูล
                        </Button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="py-2 text-center text-[#339A80] text-bold">
                  ไม่พบข้อมูลค้นหา
                </div>
              )}
            </div>
          </div>

          <div className="px-24 sm:px-12 flex justify-center">
            <button
              className="button-theme-pg flex justify-center items-center w-56 py-4 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan "
              onClick={() => {
                navigate("/dataAccessRights");
              }}
            >
              <div className="text-sm text-[#000000]">
                สถานะการเข้าถึงข้อมูลผู้ป่วย
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchDataPatient;
